import { CitiesProvider } from './CitiesProvider';
import { IComponentDefinition } from '../../../grapesJs/reactComponentsRegistry/types';

export const citiesProviderComponent: IComponentDefinition = {
  id: 'citiesProvider',
  component: CitiesProvider,
  tagName: 'citiesprovider',
  stylable: false,
  droppable: true,
  defaultAttributes: {
    style: 'display: contents',
    defaultCity: 'Москва',
  },
  traits: [
    {
      type: 'string',
      name: 'defaultCity',
      label: 'Город по умолчанию',
      placeholder: 'Например, Москва',
    },
  ],
  block: {
    label: 'Cities Provider',
    category: 'Cities',
    content: `<CitiesProvider />`,
  },
};
